export default [function () {

    return {
        require: ['?^gwAbExperimentSegmentation', '?^gwCampaignSegmentation', '?^gwBrandingSegmentation', '?^gwQueryParamsSegmentation', '?^gwLocationSegmentation'], // one of these controllers should be present
        restrict: 'EA',
        scope: {
            is: '@' // {Array} options to be checked if they hit the variant.
        },
        link: function link(scope, element, attrs, parentCtrls) {

            var parentCtrl = parentCtrls.find(function (ctrl) {
                return !!ctrl;
            });
            if (!parentCtrl) {
                throw new Error('gw-segmentation-option directive must be wrapped by one of the segmentation directives');
            }
            // initially hide the option
            element.hide();

            var optionModel = {
                isHidden: true, // initially hide the element while promise is being resolved
                isDefault: attrs.defaultOption !== undefined,
                optionValues: scope.is ? JSON.parse(scope.is) : [],
                show: function show() {
                    element.show();
                    this.isHidden = false;
                },
                hide: function hide() {
                    element.hide();
                    this.isHidden = true;
                }
            };

            // inform the parent directive
            parentCtrl.registerSegmentOption(optionModel);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/SegmentationOptionDirective.js
// module id = 1057
// module chunks = 0